<template lang="pug">
  .root
    component-header-index(v-if="$store.state.user.email")
    component-header-login(v-if="!$store.state.user.email")
    div(class="container-flex")
      div(class="content-info")
        <h3 style="text-align:center">プライバシーポリシー</h3>
        div(class="term-content")
          <div v-html="text"></div>

    component-footer-index(v-if="$store.state.user.email")
    component-footer-login(v-if="!$store.state.user.email")
</template>

<style src="./Privacy.scss" lang="scss" scoped>
</style>

<script>
import { getStaticPrivacyPolicy } from '@/api/system';

export default {
  name: "TopBroadcastIndex",
  components: {
  },
  data() {
    return {
      ui: {
      },
      oneNewsInfo: {

      },
      text: '',
    }
  },
  props: {},
  computed: {},
  watch: {},
  mounted() {},
  async created() {
    const res = await getStaticPrivacyPolicy();
    this.text = res.privacy_policy.content.describe;
  },
  updated() {},
  destroyed() {},
  methods: {
  }
};
</script>
